import React from "react";
import { LockOutlined } from '@ant-design/icons';
import { Form } from '@ant-design/compatible';

// import '@ant-design/compatible/assets/index.css';


import { Input, Button } from "antd";
import FormItem from "antd/lib/form/FormItem";
import AuthService from "../../Services/AuthService";

interface Props {
  changeState: (newState: string) => void;
  setError: (error: string) => void;
  setEmail: (email: string) => void;
  setPassword: (password: string) => void;
  form: any;
  initialLoginType?: "Password";
  email: string | null;
  user: any;
}

interface State {
  loginType: "Password";
  loggingIn: boolean;
  currentForm: string;
}

class NewPasswordRequired extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      loginType: "Password",
      loggingIn: false,
      currentForm: "login",
    };
  }
  setLoginType = (type: "Password"): void => {
    this.setState({
      loginType: type,
    });
  };

  submitNewPassword = (): void => {
    const { form } = this.props;
    this.setState({
      loggingIn: true,
    });
    form.validateFields(async (err: boolean, values: any) => {
      if (err) {
        this.setState({
          loggingIn: false,
        });
        return;
      }
      // Initiate Auth, and once we receive the challenge back, we can redirect the user
      const authService = new AuthService();
      try {
        if (this.props.email) {
          const resp = await authService.submitNewPassword(
            this.props.user,
            this.props.email,
            values.password
          );
          this.props.changeState("signIn");
        } else {
          this.props.changeState("signIn");
        }
      } catch (e) {
        this.props.setError(e.message || "An error occurred");
        // this.props.changeState("signIn");
      }
    });
  };
  goToSignup = (): void => {
    this.props.changeState("signUp");
  };
  handleKeyPress = () => {
    console.log("event");
    // this.loginWithPassword();
  };
  checkPassword = (rule: any, value: any, callback: any) => {
    const { form } = this.props;
    if (value && value !== form.getFieldValue("password")) {
      callback("The passwords don't match");
    } else {
      callback();
    }
  };
  render(): React.ReactElement {
    const { getFieldDecorator } = this.props.form;
    const { loggingIn } = this.state;

    return (
      <Form>
        <h2>New Password Required</h2>
        <FormItem>
          {getFieldDecorator("password", {
            rules: [{ required: true, message: "Please input your Password!" }],
          })(
            <Input
              prefix={<LockOutlined style={{ fontSize: 13 }} />}
              type="password"
              placeholder="Password"
              onPressEnter={() => {
                this.handleKeyPress();
              }}
            />
          )}
        </FormItem>
        <FormItem>
          {getFieldDecorator("confirmPassword", {
            rules: [
              { required: true, message: "Please retype your Password!" },
              { validator: this.checkPassword },
            ],
          })(
            <Input
              prefix={<LockOutlined style={{ fontSize: 13 }} />}
              type="password"
              placeholder="Confirm Password"
              onPressEnter={() => {
                this.handleKeyPress();
              }}
            />
          )}
        </FormItem>

        <FormItem>
          <>
            <Button
              type="primary"
              style={{ width: "100%" }}
              className="login-form-forgot"
              onClick={(): void => this.submitNewPassword()}
              loading={loggingIn}
              disabled={loggingIn}
            >
              Submit
            </Button>
          </>
        </FormItem>
      </Form>
    );
  }
}

const WrappedNewPasswordRequired = Form.create<Props>()(NewPasswordRequired);

export default WrappedNewPasswordRequired;
